module.exports = __webpack_public_path__ + "76fca72f6d180d3f14a55653b8937b5e.svg";